/* eslint-disable react-hooks/exhaustive-deps */
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import useApi, { httpClient } from "../../hooks/useApi";
import Constants from "../../utils/Constants";
import MESSAGES from "../../utils/Messages";

// バリデーション定義
const schema = z.object({
  id: z.string(),
  name: z
    .string()
    .min(1, MESSAGES.REQUIRED)
    .max(
      Constants.ONE_LINE_TEXT_MAX,
      MESSAGES.TEXT_MAX_ERROR(Constants.ONE_LINE_TEXT_MAX)
    ),
  furigana: z
    .string()
    .max(
      Constants.ONE_LINE_TEXT_MAX,
      MESSAGES.TEXT_MAX_ERROR(Constants.ONE_LINE_TEXT_MAX)
    ),
  nameEnglish: z
    .string()
    .max(
      Constants.ONE_LINE_TEXT_MAX,
      MESSAGES.TEXT_MAX_ERROR(Constants.ONE_LINE_TEXT_MAX)
    ),
  eMailAddress: z
    .string()
    .min(1, MESSAGES.REQUIRED)
    .max(
      Constants.ONE_LINE_TEXT_MAX,
      MESSAGES.TEXT_MAX_ERROR(Constants.ONE_LINE_TEXT_MAX)
    )
    .email(MESSAGES.EMAIL_ERROR),
  isAdministrator: z.boolean(),
});
const UserForm = ({ targetData = {}, closeHandler }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onBlur",
    resolver: zodResolver(schema),
  });
  const { connect } = useApi();

  // 新規作成時にフォームをクリア
  const [disableEmail, setDisableEmail] = useState(false);
  useEffect(() => {
    if (Object.keys(targetData).length !== 0) {
      reset({ ...targetData });
      setDisableEmail(true);
    } else {
      reset({
        id: "",
        name: "",
        furigana: "",
        nameEnglish: "",
        eMailAddress: "",
        isAdministrator: false,
      });
      setDisableEmail(false);
    }
  }, [targetData]);

  // API POST
  const onSubmit = async (data) => {
    const result = await connect(() => {
      return httpClient.post("../api/mscsadmin/UpsertAuditor", data);
    }, "保存しました");
    console.log("post end", data); //TODO:開発用
    closeHandler(result);
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="name"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              label="ユーザー名"
              required
              {...field}
              error={!!errors.name}
              helperText={errors.name ? errors.name.message : ""}
            />
          )}
        />
        <br />
        <Controller
          name="furigana"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              label="フリガナ"
              {...field}
              error={!!errors.furigana}
              helperText={errors.furigana ? errors.furigana.message : ""}
            />
          )}
        />
        <br />
        <Controller
          name="nameEnglish"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              label="Name(English)"
              {...field}
              error={!!errors.nameEnglish}
              helperText={errors.nameEnglish ? errors.nameEnglish.message : ""}
            />
          )}
        />
        <br />
        <Controller
          name="eMailAddress"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <TextField
              label="メールアドレス"
              disabled={disableEmail}
              required
              {...field}
              error={!!errors.eMailAddress}
              helperText={
                errors.eMailAddress ? errors.eMailAddress.message : ""
              }
            />
          )}
        />
        <br />
        <Controller
          name="isAdministrator"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <FormControl>
              <InputLabel required>システム管理者</InputLabel>
              <Select
                sx={{ maxWidth: "15rem" }}
                {...field}
                error={!!errors.eMailAddress}
                helperText={
                  errors.isAdministrator ? errors.isAdministrator.message : ""
                }
              >
                <MenuItem key={false} value={false}>
                  いいえ
                </MenuItem>
                <MenuItem key={true} value={true}>
                  はい
                </MenuItem>
              </Select>
            </FormControl>
          )}
        />
        <br />
        <Button type="submit" disabled={isSubmitting}>
          保存
        </Button>
      </form>
    </>
  );
};

export default UserForm;
